// src/pages/RequestExhaustQuote.jsx
import React from "react";
import { Link } from "react-router-dom";

const HERO_MEDIA = "/assets/exhaust-hero.mp4"; 

export default function RequestExhaustQuote() {
  const isVideo = /\.mp4($|\?)/i.test(HERO_MEDIA);

  return (
    <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h1 className="mt-6 text-2xl sm:text-3xl font-semibold">
        Build Your Custom Exhaust
      </h1>

      <section className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* LEFT: media */}
        <div className="w-full">
          <div className="overflow-hidden rounded-2xl shadow-lg bg-black">
            {isVideo ? (
              <video
                className="w-full h-full"
                src={HERO_MEDIA}
                autoPlay
                muted
                loop
                playsInline
              />
            ) : (
              <img
                src={HERO_MEDIA}
                alt="Unlimited Levels Exhaust"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>

        {/* RIGHT: form -> Formspree */}
        <div className="w-full">
          <form
            action="https://formspree.io/f/xeorbgdy"
            method="POST"
            encType="multipart/form-data"
            className="space-y-4"
          >
            {/* metadata (helps your inbox filter) */}
            <input type="hidden" name="form_name" value="Exhaust Quote" />
            <input type="hidden" name="_subject" value="Exhaust Quote — Unlimited Levels" />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-sm font-medium">Full Name *</label>
                <input name="name" required className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Email *</label>
                <input type="email" name="email" required className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Phone *</label>
                <input name="phone" className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Location (City, State/Country) *</label>
                <input name="location" className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Year *</label>
                <input name="year" required className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Make *</label>
                <input name="make" required className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Model *</label>
                <input name="model" required className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm font-medium">Trim</label>
                <input name="trim" className="mt-1 w-full rounded-xl border px-3 py-2" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-sm font-medium">System Type *</label>
                <select name="system_type" required className="mt-1 w-full rounded-xl border px-3 py-2">
                  <option value="">Select…</option>
                  <option>Cat-Back</option>
                  <option>Axle-Back</option>
                  <option>Valved Cat-Back</option>
                  <option>Downpipes Only</option>
                  <option>Headers</option>
                </select>
              </div>
              <div>
                <label className="text-sm font-medium">Material *</label>
                <select name="material" required className="mt-1 w-full rounded-xl border px-3 py-2">
                  <option value="">Select…</option>
                  <option>Stainless Steel</option>
                  <option>Titanium</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-sm font-medium">Tip Style</label>
                <select name="tips" className="mt-1 w-full rounded-xl border px-3 py-2">
                  <option>Carbon Fiber</option>
                  <option>Polished Silver</option>
                  <option>Black</option>
                  <option>Blue</option>
                  <option>Gold</option>
		  <option>Purple</option>
                </select>
              </div>
                          </div>

            <div>
              <label className="text-sm font-medium">Upload Photos of Your Car</label>
              <input type="file" name="photos" multiple className="mt-1 block w-full rounded-xl border px-3 py-2" />
              <p className="text-xs text-neutral-500 mt-1">
                Side or 3/4 angles work best. (You can attach multiple images.)
              </p>
            </div>

            <div>
              <label className="text-sm font-medium">Build Notes / Goals</label>
              <textarea
                name="notes"
                rows={6}
                className="mt-1 w-full rounded-xl border px-3 py-2"
                placeholder="Sound preference, drone sensitivity, track use, etc."
              />
            </div>

            <button
              type="submit"
              className="mt-2 inline-flex items-center rounded-xl bg-black px-5 py-3 text-white font-semibold shadow hover:opacity-90 transition"
            >
              Submit Request
            </button>

            <p className="text-xs text-neutral-500 mt-2">
              By submitting, you agree we may contact you about your quote. We don't share your info.
            </p>

            <div className="pt-4">
              <Link to="/exhaust-systems" className="text-sm underline">
                ← Back to Exhaust
              </Link>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}
